import {Dispatch, SetStateAction} from "react";
import {useEventListener} from "usehooks-ts";
import {Camera} from "./camera";
import {ToolState} from "./tools";
import {DiagramAnyObject} from "./types";

export function useKeyboardShortcuts({
  setToolState,
  setCamera,
  setIsHoldingSpace,
  setIsHoldingAlt,
  selectedObject,
  deleteObject,
}: {
  setToolState: Dispatch<SetStateAction<ToolState>>;
  setCamera: Dispatch<SetStateAction<Camera>>;
  setIsHoldingSpace: Dispatch<SetStateAction<boolean>>;
  setIsHoldingAlt: Dispatch<SetStateAction<boolean>>;
  selectedObject: DiagramAnyObject | null;
  deleteObject: Dispatch<DiagramAnyObject>;
}) {
  useEventListener("keydown", ev => {
    // Do not consume inputs if the user is typing into a box!
    if (["INPUT", "TEXTAREA"].includes((ev.target as HTMLElement).tagName)) {
      return;
    }

    if (ev.key === "1") {
      setToolState({tool: "pan"});
    } else if (ev.key === "2") {
      setToolState({tool: "select", selectedObjectId: null, dragging: null});
    } else if (ev.key === "3") {
      setToolState({tool: "createNode"});
    } else if (ev.key === "4") {
      setToolState({tool: "createConnection", drawing: null});
    } else if (ev.ctrlKey && ev.key === "0") {
      ev.preventDefault();
      setCamera(prev => {
        const next = prev.clone();
        next.targetZoomStep = 1.0;
        return next;
      });
    } else if (ev.ctrlKey && ev.key === "-") {
      ev.preventDefault();
      setCamera(prev => {
        const next = prev.clone();
        next.targetZoomStep -= 1;
        return next;
      });
    } else if (ev.ctrlKey && ev.key === "=") {
      ev.preventDefault();
      setCamera(prev => {
        const next = prev.clone();
        next.targetZoomStep += 1;
        return next;
      });
    } else if (ev.key === " ") {
      ev.preventDefault();
      setIsHoldingSpace(true);
    } else if (ev.key === "Alt") {
      ev.preventDefault();
      setIsHoldingAlt(true);
    } else if (ev.key === "Backspace" || ev.key === "Delete") {
      ev.preventDefault();

      if (selectedObject != null) {
        deleteObject(selectedObject);
      }
    }
  });

  useEventListener("keyup", ev => {
    if (ev.key === " ") {
      ev.preventDefault();
      setIsHoldingSpace(false);
    } else if (ev.key === "Alt") {
      ev.preventDefault();
      setIsHoldingAlt(false);
    }
  });
}
